import { getBaseURL, get, post, deletes } from "./request";

const HttpManager = {

  // 获取用户信息
  getUserInfo:() => get("/api/getUserInfo"),

  // 获取图片信息
  attachImageUrl: (url) => url ? `/api${url}` : "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png",
  // 获取OSS文件信息
  getOssFileInfo: (url) => `api/aliyunOss/getOssFileInfo?fileurl=${url}`,

  // =======================> 用户 API 完成

  signInByemail: ({email,password})=>post(`/api/user/email/status`, {email,password}),
  // 删除用户
  deleteUser: (id) => get(`/api/consumer/user/delete?id=${id}`),
  // 更新用户信息
  updateUserMsg: ({id,username,sex,phoneNum,email,birth,introduction,location}) => post(`/api/consumer/user/update`, {id,username,sex,phoneNum,email,birth,introduction,location}),
  updateUserPassword: ({id,username,oldPassword,password}) => post(`/api/consumer/user/updatePassword`, {id,username,oldPassword,password}),
  // 返回指定ID的用户
  getUserOfId: (id) => get(`/api/consumer/user/detail?id=${id}`),
  // 更新用户头像
  uploadUrl: (userId) => `/api/consumer/user/avatar/update?id=${userId}`,

  // =======================> 歌单 API 完成
  // 获取全部歌单
  getSongList: () => get("/api/songList"),
  // 获取歌单类型
  getSongListOfStyle: (style) => get(`/api/songList/style/detail?style=${style}`),
  // 返回标题包含文字的歌单
  getSongListOfLikeTitle: (keywords) => get(`/api/songList/likeTitle/detail?title=${keywords}`),
  // 返回歌单里指定歌单ID的歌曲
  getListSongOfSongId: (songListId) => get(`/api/listSong/detail?songListId=${songListId}`),

  // =======================> 歌手 API  完成
  // 返回所有歌手
  getAllSinger: () => get("/api/singer"),
  // 通过性别对歌手分类
  getSingerOfSex: (sex) => get(`/api/singer/sex/detail?sex=${sex}`),

  // =======================> 收藏 API 完成
  // 返回的指定用户ID的收藏列表
  getCollectionOfUser: (userId) => get(`/api/collection/detail?userId=${userId}`),
  // 添加收藏的歌曲 type: 0 代表歌曲， 1 代表歌单
  setCollection: ({userId,type,songId}) => post(`/api/collection/add`,{userId,type,songId}),

  deleteCollection: (userId, songId) => deletes(`/api/collection/delete?userId=${userId}&&songId=${songId}`),

  isCollection: ({userId, type, songId}) => post(`/api/collection/status`, {userId, type, songId}),

  // =======================> 评分 API 完成
  // 提交评分
  setRank: ({songListId,consumerId,score}) => post(`/api/rankList/add`, {songListId,consumerId,score}),
  // 获取指定歌单的评分
  getRankOfSongListId: (songListId) => get(`/api/rankList?songListId=${songListId}`),
  // 获取指定用户的歌单评分
  getUserRank: (consumerId, songListId) => get(`/api/rankList/user?consumerId=${consumerId}&songListId=${songListId}`),

  // =======================> 评论 API 完成
  // 添加评论
  setComment: ({userId,content,songId,songListId,nowType}) => post(`/api/comment/add`, {userId,content,songId,songListId,nowType}),
  // 删除评论
  deleteComment: (id) => get(`/api/comment/delete?id=${id}`),
  // 点赞
  setSupport: ({id,up}) => post(`/api/comment/like`, {id,up}),
  // 返回所有评论
  getAllComment: (type, id) => {
    let url = "";
    if (type === 1) {
      url = `/api/comment/songList/detail?songListId=${id}`;
    } else if (type === 0) {
      url = `/api/comment/song/detail?songId=${id}`;
    }
    return get(url);
  },

  // =======================> 歌曲 API
  // 返回指定歌曲ID的歌曲
  getSongOfId: (id) => get(`/api/song/detail?id=${id}`),
  // 返回指定歌手ID的歌曲
  getSongOfSingerId: (id) => get(`/api/song/singer/detail?singerId=${id}`),
  // 返回指定歌手名的歌曲
  getSongOfSingerName: (keywords) => get(`/api/song/singerName/detail?name=${keywords}`),
  // 下载音乐
  downloadMusic: (url) => get(url, { responseType: "blob" }),

  //======================> 点赞api的优化 避免有些是重复的点赞！新增数据表了得

  testAlreadySupport:({commentId,userId}) => post(`/api/userSupport/test`, {commentId,userId}),

  deleteUserSupport:({commentId,userId}) => post(`/api/userSupport/delete`, {commentId,userId}),

  insertUserSupport:({commentId,userId}) => post(`/api/userSupport/insert`, {commentId,userId}),

  //获取所有的海报
  getBannerList: () => get("/api/banner/getAllBanner"),
  // 获取会员规则信息
  getMemberRuleInfo:() => get("/api/membership/rules/getMemberRuleInfo", ),
  // 发起支付
  getCommonPay:({payPlatformType,payBizType,bizId}) => post("/api/commonPay",{payPlatformType,payBizType,bizId}),
  // 查询订单状态
  queryOrderStatus: (orderNo) => get(`/api/query-order-status/${orderNo}`),
  // 支付记录分页
  getLoginUserPayInfoPage:({page,size}) => post("/api/getLoginUserPayInfoPage",{page,size}),
  // 下载记录分页
  getLoginDownloadRecordPage:({page,size}) => post("/api/getLoginDownloadRecordPage",{page,size}),
  // 获取歌曲排行榜
  getTopSongs: () => get("/api/song/getTopSongs"),
  // 获取收藏的歌曲列表-分页
  getCollectionSongPage:({pageNo,pageSize}) => post("/api/collection/getCollectionSongPage",{pageNo,pageSize}),
  // 取消收藏的歌曲
  cancelCollection:(id) => get(`/api/collection/delete?songId=${id}`),
  // 查询最新制作人单曲
  getTheLatestSongs: () => get("/api/song/getTheLatestSongs"),
  //  获取歌手单曲-分页
  getSingerPage:(params) => post("/api/singer/getSingerPage",params),
  // 获取歌手信息
  getSingerDetailInfo:(singerId) => get(`/api/singer/getSingerDetailInfo?singerId=${singerId}`),
  // 获取指定歌手的单曲-分页
  getSongsBySingerIdPage:(params) => post("/api/song/getSongsBySingerIdPage",params),

  getSongStyleListAll:() => get("/api/songStyle/getSongStyleListAll",),

  signOut:() => get("/api/consumer/signOut"),

  // 查询最新单曲
  getNewTheLatestSongs: () => get("/api/song/getNewTheLatestSongs"),
  // 查询最新单曲

  // =======================> 播放量统计 API
  // 上报播放记录
  recordPlay: ({songId, playSource}) => post(`/api/song/play-record`, {songId, playSource}),

};

export { HttpManager };
